/**
 * 🔴🔴 O TAMANHO DA FONTE DO NÚMERO DO `KpiCard` — item 27, segunda volta
 * (M2, 28/09/2026).
 *
 * > **Matheus:** *"preciso que fique `R$ xx.xxx.xxx,xx` sem quebrar"*.
 *
 * ── ⛔ O que a primeira cura fez de errado, e ela era MINHA
 *
 * Em 25/09 o item 27 foi fechado com `min-w-0` + `[overflow-wrap:anywhere]`.
 * ✅ Isso resolveu o problema real daquele dia — o número empurrava a página
 * inteira para fora da viewport. 🔴 **E criou este:** `anywhere` autoriza a
 * quebra em QUALQUER ponto, **inclusive entre o `R$` e o número**.
 *
 * ⚠️ **A cura virou a causa**, e o teste não pegou porque ele usava
 * `R$ 18.203,11/mês` — o valor mais LONGO medido no beta, que **cabia**.
 * 🔴 **O valor mais longo não é o teste certo: o teste certo é a pior RAZÃO
 * entre o valor e a largura da coluna** — e a coluna mais estreita do Resumo
 * tem 242 px com 4 cartões.
 *
 * ── ✅ O que esta função faz
 *
 * Em vez de deixar quebrar, ela **encolhe para caber**: o número fica sempre
 * em UMA linha (`whitespace-nowrap` no componente) e a fonte desce por
 * degraus, conforme o comprimento do que vai ser escrito.
 *
 * ⚠️ **O sufixo conta**, porque `/mês` ocupa espaço na mesma linha — ele entra
 * como **3 caracteres equivalentes** (fonte menor, ~30 px contra ~14 px por
 * dígito do número).
 *
 * 🔴 **Os degraus foram calibrados contra a coluna de 242 px** (largura útil
 * ≈ 202 px depois do `p-5`), e **conferidos no navegador depois** — ❌ não
 * escolhidos de cabeça. É a régua de 25/09: *"estimou de cabeça e escreveu o
 * número como se fosse medido"*.
 */

/** Quanto o sufixo (`/mês`) "vale" em caracteres do número. */
export const PESO_DO_SUFIXO = 3;

/**
 * A classe de tamanho para um valor de KPI.
 *
 * ⚠️ Devolve classe do Tailwind, ❌ nunca `style` em linha: propriedade com
 * variante responsiva nasce classe nos dois lados — **estilo em linha ganha de
 * qualquer classe, e em silêncio** (a régua do rodapé do Kanban, 26/09).
 */
export function tamanhoDoNumero(valor: string, sufixo?: string): string {
  const n = valor.length + (sufixo ? PESO_DO_SUFIXO : 0);
  if (n <= 13) return 'text-2xl';
  if (n <= 15) return 'text-xl';
  if (n <= 17) return 'text-lg';
  return 'text-base';
}
